import {Component, Input, Signal, computed, inject} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormLabelComponent} from "../../../shared/elements/form-label/form-label.component";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {BrowserNotificationsComponent} from "../../helper/browser-notifications/browser-notifications.component";
import {FormSwitchComponent} from "../../../shared/elements/form-switch/form-switch.component";
import {TooltipComponent} from "../../../shared/elements/tooltip/tooltip.component";
import {ContentComponent} from "../../../shared/elements/content/content.component";
import {FirebaseService} from "../../../shared/services/firebase.service";
import {LanguageService} from "../../../shared/services/language.service";
import {TYPE} from "../../../shared/types/types";

@Component({
  selector: 'app-profile-push-settings',
  imports: [
    FormLabelComponent,
    TranslatePipe,
    BrowserNotificationsComponent,
    FormSwitchComponent,
    TooltipComponent,
    ContentComponent
  ],
  templateUrl: './profile-push-settings.component.html',
  styles: [`
    .push-toggle-row {
      min-height: 2rem;
    }

    .warning-icon-slot {
      width: 2.25rem;
      min-width: 2.25rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  `]
})
export class ProfilePushSettingsComponent {
  public firebase: FirebaseService = inject(FirebaseService);
  private languageService: LanguageService = inject(LanguageService);

  @Input({required: true}) public fG!: FormGroup;
  @Input() public automaticResetDays: number | null = null;

  public notificationsTooltipText: Signal<string> = computed(() => {
    switch (this.firebase.notificationState()) {
      case TYPE.FirebaseNotificationsState.INITIALIZING: return this.languageService.getTranslationByKey('NONOTIFICATIONSSETUPNOTPERFORMED');
      case TYPE.FirebaseNotificationsState.ERROR: return this.languageService.getTranslationByKey('NONOTIFICATIONSERRORDUREINGSETUP');
      case TYPE.FirebaseNotificationsState.UNDEFINED: return this.languageService.getTranslationByKey('NONOTIFICATIONSUNKNOWNBROWSERSUPPORT');
      case TYPE.FirebaseNotificationsState.UNSUPPORTED: return this.languageService.getTranslationByKey('NONOTIFICATIONSUNSUPPORTEDBYBROWSER');
      case TYPE.FirebaseNotificationsState.DENIED: return this.languageService.getTranslationByKey('NONOTIFICATIONSDENIEDBYUSER');
      case TYPE.FirebaseNotificationsState.DEFAULT: return this.languageService.getTranslationByKey('NONOTIFICATIONSNORESPONSEFROMUSER');
      default: return '';
    }
  });
}
